import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Interceramic_Title } from '../../../../../utils/EN/Modals/SpotsModals';

const ModalSpotsInterceramic = () => {
  return (
    <>
      <ModalVideo
        id="spot-interceramic"
        dataText={Interceramic_Title}
        videoSrc="https://player.vimeo.com/video/721257955?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_INTERCERAMIC"
      />
    </>
  );
};

export default ModalSpotsInterceramic;
